import React from 'react';
import { Campaign } from '../../types';
import { SearchableDropdown } from '../SearchableDropdown';

interface CampaignSelectProps {
  campaigns: Campaign[];
  selectedId: string | null;
  onChange: (id: string) => void;
}

export function CampaignSelect({ campaigns, selectedId, onChange }: CampaignSelectProps) {
  if (campaigns.length === 0) {
    return (
      <span className="text-sm italic text-gray-400">No campaigns</span>
    );
  }
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-gray-500">Campaign</span>
      <SearchableDropdown
        options={campaigns.map((campaign) => ({
          value: campaign.id,
          label: `${campaign.name}${campaign.archivedAt ? ' (archived)' : ''}`,
          searchText: `${campaign.name} ${campaign.id}`,
        }))}
        value={selectedId}
        onChange={(value) => {
          if (value !== null) onChange(value);
        }}
        placeholder="Select campaign"
        searchPlaceholder="Search campaigns"
        ariaLabel="Campaign"
        preserveOrder
        className="min-w-[15rem] flex-1"
      />
    </div>
  );
}
